import { render, staticRenderFns } from "./UpNextPage.vue?vue&type=template&id=06041592&"
import script from "./UpNextPage.vue?vue&type=script&lang=js&"
export * from "./UpNextPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports